export enum AffiliationErrorTypeEnum {
    SAME_COMPANY = "same_company",
}
export const affiliationErrorTypeEnum = Object.values(AffiliationErrorTypeEnum);
